import React,{useState} from "react";
import classes from './EntryDropdown.module.css';
import DownArrowDropdown from "../../../Global/DownArrowDropdown/DownArrowDropdown";

const EntryDropdown = ({monthOptionsArr, tripMonthHandler}) => {

    let [dsp,setDsp] = useState("none");

    const dspHandler = () =>{
        setDsp("block");
    }

    const dspRemoveHandler = () =>{
        setDsp("none");
    }

    const tripHandler = (e)=>{
        dspRemoveHandler();
        if(window.location.pathname.includes('exploretrips')){

        }else if(window.location.pathname==='/'){
            tripMonthHandler(e)
        }
    }

    return (
        <>
            <div onMouseLeave={dspRemoveHandler} className={classes['entry-component-search-box-container']}>
                    <div onClick={dspHandler} className={classes['entry-component-search-box']} >
                        <p style={{margin:0}}>When are you free?</p>
                        <DownArrowDropdown />
                    </div>
                    <div className={classes['entry-dropdown-container']} style={{display:`${dsp}`}}>
                        <div style={{margin:0}}>
                        {
                            monthOptionsArr.map(mp=>{
                                return <p onClick={()=>{tripHandler(mp.value)}} className={classes['entry-dropdown-options']} >{mp.label}</p>
                            })
                        }
                        
                        
                        </div>
                    </div>
                </div>
        </>
    )
};

export default EntryDropdown;